export default __webpack_public_path__ + "adee489f0b0e67230072e61818fcbf1a.svg";